import { UserViewModel } from '@api/index';

export enum ACTIONS {
  SET_USER_INFO,
  SET_TOKEN,
  SET_TOKEN_EXPIRATION_DATE,
  CLEAR,
}

export type Action =
  | { type: ACTIONS.SET_USER_INFO; payload: UserViewModel }
  | { type: ACTIONS.SET_TOKEN_EXPIRATION_DATE; payload: Date }
  | { type: ACTIONS.CLEAR };

export interface AuthState {
  userInfo: UserViewModel;
  tokenExpirationDate: Date | null;
  loginInfo?: LoginInfo;
}

export type LoginInfo = { token: string; userId: string };
